import $http from "@/plugins/axios";

const StatisticService = {
    getStatistic (botCode, fromDate, toDate) {
        return $http.get(`/live-support/statistic/${botCode}/${fromDate}/${toDate}/`)
    },
    saveAuditExportStatistic (botCode, fromDate, toDate) {
        return $http.get(`/live-support/statistic/${botCode}/${fromDate}/${toDate}/save_audit_export/`)
    },
};

export default StatisticService
